import React, { useEffect, useState } from "react";
import classes from './FinishedGoods.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Pencil, Trash2, X } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import FinishedGoodsModal from "./FinishedGoodsModal";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Swal from "sweetalert2";

const FinishedGoods = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Modal states
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(true);

    // Search and filter states
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    const [deliveredOrders, setDeliveredOrders] = useState([]);

    // Fetch finished goods transfers from API
    const fetchFinishedGoodsTransfers = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");

            const response = await axios.get(
                `${BASE_URL}/v1/finished_goods_transfer`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            console.log("API Response:", response.data);

            if (response.data?.status && Array.isArray(response.data.data)) {
                setDeliveredOrders(response.data.data);
            } else {
                setDeliveredOrders([]);
                Swal.fire("Info", "No finished goods transfers found", "info");
            }
        } catch (error) {
            console.error("Error fetching finished goods transfers:", error);
            Swal.fire("Error", "Failed to load finished goods transfers", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFinishedGoodsTransfers();
    }, []);

    /* =========================
       FILTER DELIVERED ORDERS
    ========================== */
    const getFilteredOrders = () => {
        let filtered = deliveredOrders;

        // Apply search filter
        if (searchTerm) {
            filtered = filtered.filter(order =>
                order.transfer_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                order.production_order_number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                order.transferred_by?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                order.target_product?.name?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply status filter
        if (statusFilter !== "all") {
            filtered = filtered.filter(order =>
                order.status?.toLowerCase() === statusFilter.toLowerCase()
            );
        }

        return filtered;
    };

    /* =========================
       HANDLE VIEW DETAILS
    ========================== */
    const handleViewDetails = (order) => {
        setViewData(order);
        setIsViewModalOpen(true);
    };


    const handleDeleteOrder = async (id) => {
        if (window.confirm("Are you sure you want to delete this transfer record?")) {
            try {
                const token = localStorage.getItem("authToken");

                const response = await axios.delete(
                    `${BASE_URL}/v1/finished_goods_transfer/${id}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (response.data?.status) {
                    Swal.fire("Success", "Transfer record deleted successfully!", "success");

                    fetchFinishedGoodsTransfers();
                } else {
                    Swal.fire("Error", response.data?.message || "Failed to delete transfer", "error");
                }
            } catch (error) {
                console.error("Error deleting transfer:", error);
                Swal.fire("Error", "Failed to delete transfer record", "error");
            }
        }
    };

    const handleRefreshList = () => {
        fetchFinishedGoodsTransfers();
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "0.00";
        return new Intl.NumberFormat("en-NG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(value));
    };

    const filteredOrders = getFilteredOrders();

    const totalTransfers = deliveredOrders.length;
    const completedTransfers = deliveredOrders.filter(order => order.status === "Completed" || order.status === "completed").length;
    const inProgressTransfers = deliveredOrders.filter(order => order.status === "In Progress" || order.status === "in_progress").length;

    const thisMonthTransfers = deliveredOrders.filter(order => {
        if (!order.transfer_date) return false;
        const orderDate = new Date(order.transfer_date);
        const now = new Date();
        return orderDate.getMonth() === now.getMonth() &&
            orderDate.getFullYear() === now.getFullYear();
    }).length;

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button
                        className={classes.btns}
                        onClick={() => navigate('/transactions/sales-invoice/sale')}
                    >
                        Sales Invoice
                    </button>
                    <button
                        className={classes.btns}
                        onClick={() => navigate('/Inventory/PurchaseOrder')}
                    >
                        Purchase Order
                    </button>
                    <button
                        className={`${classes.btns} ${isActive ? classes.active : ""}`}
                        onClick={() => setIsActive(true)}
                    >
                        Stock Delivery
                    </button>
                    <button
                        onClick={() => navigate('/settings/product-services')}
                        className={`${classes.btns} ${classes.greens}`}
                    >
                        Product & Services
                    </button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Finished Goods</h2>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Transfers</p>
                                <p className={classes.kdptg1}>
                                    {totalTransfers}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total records</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Completed</p>
                                <p className={classes.kdptg2}>
                                    {completedTransfers}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Successful transfers</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>In Progress</p>
                                <p className={classes.kdptg3}>
                                    {inProgressTransfers}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Ongoing transfers</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>This Month</p>
                                <p className={classes.kdptg4}>
                                    {thisMonthTransfers}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Monthly transfers</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input
                                type="text"
                                className={classes.searchBar}
                                placeholder="Search transfers"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select
                                className={classes.dropdown}
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="all">All Status</option>
                                <option value="Completed">Completed</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Pending">Pending</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>
                        <div className={classes.inputWrapper}>
                            <input
                                type="text"
                                className={classes.searchBars}
                                placeholder="Filter..."
                            />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>

                    <button
                        className={classes.btnss}
                        onClick={() => setIsModalOpen(true)}
                    >
                        + Transfer to Finished Goods
                    </button>
                </div>

                <table className={classes.invoiceTable}>
                    <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Transfer No</th>
                            <th>Production Order No</th>
                            <th>Transfer Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}>Loading...</td>
                            </tr>
                        ) : filteredOrders.length > 0 ? (
                            filteredOrders.map((row, index) => {
                                // Handle status display
                                const status = row.status || "Pending";
                                const statusColor = status === "Completed" || status === "completed"
                                    ? "#28a745"
                                    : status === "In Progress" || status === "in_progress"
                                        ? "#ffc107"
                                        : "#dc3545";

                                // Format date
                                const transferDate = row.transfer_date
                                    ? new Date(row.transfer_date).toISOString().split('T')[0]
                                    : "N/A";

                                return (
                                    <tr key={row.id}>
                                        <td>{index + 1}</td>
                                        <td>{row.transfer_no || "N/A"}</td>
                                        <td>{row.production_order?.production_number || "N/A"}</td>
                                        <td>{transferDate}</td>
                                        <td>
                                            <span style={{
                                                padding: "4px 8px",
                                                borderRadius: "4px",
                                                backgroundColor: statusColor + "20",
                                                color: statusColor,
                                                fontSize: "12px",
                                                fontWeight: "500"
                                            }}>
                                                {status}
                                            </span>
                                        </td>
                                        <td>
                                            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                                                <Eye
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#007bff" }}
                                                    onClick={() => handleViewDetails(row)}
                                                    title="View Details"
                                                />
                                                <Pencil
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#28a745" }}
                                                    onClick={() => alert("Edit functionality to be implemented")}
                                                    title="Edit"
                                                />
                                                <Trash2
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#dc3545" }}
                                                    onClick={() => handleDeleteOrder(row.id)}
                                                    title="Delete"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}>
                                    {searchTerm || statusFilter !== "all"
                                        ? "No transfers match your search"
                                        : "No transfer records found"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* View Modal */}
            {isViewModalOpen && viewData && (
                <div className={classes.modalOverlay}>
                    <div className={classes.viewModal}>
                        <div className={classes.modalHeader}>
                            <h3>Transfer Details</h3>
                            <X
                                size={18}
                                className={classes.closeIcon}
                                onClick={() => {
                                    setIsViewModalOpen(false);
                                    setViewData(null);
                                }}
                            />
                        </div>

                        <div className={classes.modalBody}>
                            <div className={classes.viewRow}>
                                <span>Transfer Number</span>
                                <p>{viewData.transfer_no || "N/A"}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Production Order Number</span>
                                <p>{viewData.production_order?.production_number || "N/A"}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Transfer Date</span>
                                <p>{viewData.transfer_date || "N/A"}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Target Product</span>
                                <p>{viewData.target_product?.name || "N/A"}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>UOM</span>
                                <p>{viewData.uom || "N/A"}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Produced Quantity</span>
                                <p>{viewData.produced_quantity || "0"}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Cost of Production</span>
                                <p>{formatCurrency(viewData.cost_of_production)}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Unit Cost</span>
                                <p>{formatCurrency(viewData.unit_cost)}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Profit Margin</span>
                                <p>{viewData.profit_margin || "0"}%</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Total Value</span>
                                <p>{formatCurrency(viewData.total_value)}</p>
                            </div>

                            <div className={classes.viewRow}>
                                <span>Status</span>
                                <p>
                                    <span style={{
                                        padding: "4px 8px",
                                        borderRadius: "4px",
                                        backgroundColor: viewData.status === "Completed"
                                            ? "#d4edda"
                                            : viewData.status === "In Progress"
                                                ? "#fff3cd"
                                                : "#f8d7da",
                                        color: viewData.status === "Completed"
                                            ? "#155724"
                                            : viewData.status === "In Progress"
                                                ? "#856404"
                                                : "#721c24",
                                        fontSize: "12px",
                                    }}>
                                        {viewData.status || "Pending"}
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div className={classes.modalFooter}>
                            <button
                                className={classes.btnss}
                                onClick={() => {
                                    setIsViewModalOpen(false);
                                    setViewData(null);
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <FinishedGoodsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                refreshList={handleRefreshList}
            />

            <Footer />
        </div>
    );
};

export default FinishedGoods;